/* eslint-disable */
export default {
  removeMeetingWarning:
    'A funcionalidade de agendamento foi descontinuada. Utilize o {app} para agendar as suas videoconferências.',
  scheduleMeetingTips:
    'Tenha em atenção que removemos as reuniões desta aplicação. Para usufruir de reuniões, recomendamos o {app}.',
  migrateToPluginAlert:
    'Nota: esta aplicação não funcionará com a versão 2016 e inferior do Outlook e com o Internet Explorer 11. Atualize o Outlook ou mude para o Microsoft Edge. Em alternativa, mude para o {app}.',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
